exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carousel-3d-container figure{margin:0}.carousel-3d-container figcaption{background-color:rgba(0,0,0,.5);color:#fff;position:absolute;bottom:0;padding:15px;font-size:12px;min-width:100%;box-sizing:border-box}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f63486ec","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Point/effectRank.vue
// module id = 1174
// module chunks = 0